import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

import type { Shadow } from 'Types';

import SpacebarLink from 'Components/A11y/SpacebarLink';

type RoleButtonProps = {
  role: 'button';
} & React.ComponentProps<typeof SpacebarLink>;

type LinkProps = Shadow<
  React.ComponentProps<typeof Link>,
  {
    // disallow react-router-dom's object-based `to` prop
    to: string;
  }
>;
type RoleLinkProps = {
  role?: Exclude<React.AriaRole, 'button'>;
} & LinkProps;

type RoleAwareLinkProps = RoleButtonProps | RoleLinkProps;

const RoleAwareLink = forwardRef<HTMLAnchorElement, RoleAwareLinkProps>((props, ref) =>
  props.role === 'button' ? <SpacebarLink {...props} ref={ref} /> : <Link {...props} ref={ref} />
);

export default RoleAwareLink;
